<template>
  <div class="ap-search clearfix">
    <input
      type="search"
      autocomplete="off"
      :placeholder="placeholder"
      v-model="text"
      @keyup.enter="search"
    />
    <i class="fas fa-search" @click="search"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      text: "",
      placeholder: "商品名称、参考号码"
    };
  },
  methods: {
    search() {
      if (this.text) {
        window.open("#/keywordsearch/" + this.text, "_blank");
      } else {
        this.placeholder = "请输入关键字！";
        setTimeout(() => {
          this.placeholder = "商品名称、参考号码";
        }, 1000);
      }
    }
  }
};
</script>

<style lang="less">
.ap-search {
  overflow: hidden;
  display: inline-block;
  position: relative;
  padding: 0 56px 0 22px;
  height: 43px;
  width: 510px;
  border: 2px solid #999;
  border-radius: 23px;
  input {
    border: none;
    width: 100%;
    font-size: 14px;
    padding: 9px 5px;
  }
  .fa-search {
    position: absolute;
    right: 15px;
    top: 6px;
    font-size: 26px;
    cursor: pointer;
  }
}
</style>